import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Title from "../components/Title";
import * as React from "react";
import TextField from "@mui/material/TextField";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import { AutocompleteUser, useUsers } from "../hooks/useUsers";
import { useWalletBalance } from "../hooks/useWalletBalance";
import { useWalletTransactions } from "../hooks/useWalletTransactions";
import { WalletBalance } from "../models/Wallet";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingSpinner from "../components/LoadingSpinner";
import WalletTransactionList from "../components/WalletTransactionList";
import CopyToClipboard from "../components/CopyToClipboard";
import { useMyOrders } from "../hooks/useMyOrders";
import { GridColDef, GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import ErrorFallBack from "../components/ErrorFallBack";
import { format, parse } from 'date-format-parse';
import { Alert, Button, FormControl, FormHelperText, IconButton, InputLabel, Link, MenuItem, Modal, Select, SelectChangeEvent, Snackbar, Switch, Tooltip } from "@mui/material";
import { LocalTime } from "../utils/localTime";
import DownloadIcon from "@mui/icons-material/Download";
import OrderDetails from "../components/OrderDetails";
import { Storefront } from "../models/StorefrontResponse";
import { FeatureFlag, OutputFieldSetting, User, UsersResponse } from "../models/UsersResponse";
import { useStorefronts } from "../hooks/useStorefronts";
import { APIEndpoint, EndpointType, httpPut } from "../utils/apiService";
import CloseIcon from "@mui/icons-material/Close";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: any; // Needed for Hubspot

interface Props {
  storefront: Storefront
}

const Customers = (props: Props) => {

  const [balanceRefreshKey] = useState(0);
  const [customerID, setCustomerID] = useState("");
  const { users, autocompleteUsers } = useUsers(0);
  const { walletBalance } = useWalletBalance(customerID, balanceRefreshKey)
  const [transactionsRefreshKey] = useState(0);
  const { walletTransactions, walletTransactionsLoading } = useWalletTransactions(customerID, transactionsRefreshKey)
  const [userFirstName, setUserFirstName] = useState("")
  const [userLastName, setUserLastName] = useState("")
  const [userCreatedDate, setUserCreatedDate] = useState("")
  const [userEmail, setUserEmail] = useState("")
  const [userPhone, setUserPhone] = useState("")
  const [userHubspotID, setUserHubspotID] = useState("")
  const [userID, setUserID] = useState("")
  const [userSF, setUserSF] = useState("")
  const [userFeatures, setUserFeatures] = useState<string[]>([])
  const [userMinOrder, setUserMinOrder] = useState("")
  const [stripeID, setStripeID] = useState("")
  const [id, setID] = useState("")
  const [skipMarketingEmails, setSkipMarketingEmails] = useState(false)
  const [isInactive, setIsInactive] = useState(false)
  const [openOrderDetails, setOpenOrderDetails] = useState(false);
  const [orderDetailsID, setOrderDetailsID] = useState("");
  const [ignoreSuppressions, setIgnoreSuppressions] = useState(false);
  const [outputFields, setOutputFields] = useState<OutputFieldSetting[]>([]);
  const [selectedUser, setSelectedUser] = useState<User>({} as User);
  const [saveError, setSaveError] = useState("");
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarMsg, setSnackbarMsg] = useState("")

  const columns: GridColDef[] = [
    {
      field: 'id', headerName: 'ID', width: 147, renderCell: (params: GridRenderCellParams) => {
        return <Link
          component="button"
          variant="body2"
          onClick={() => {
            if (params.value != "TSG-20240420-SMPL") {
              setOrderDetailsID(params.value);
              setOpenOrderDetails(true);
            }
          }}
        >
          {params.value}
        </Link>
      }
    },
    {
      field: 'createdAt', headerName: 'Date', width: 85, renderCell: (params: GridRenderCellParams) => {
        return <div>
          <Tooltip title={LocalTime(params.value)} placement="bottom-start">
            <Typography variant="body2">{getShortDate(params.value)}</Typography>
          </Tooltip>
        </div>
      }
    },
    {
      field: 'totalPrice', headerName: 'Amount', width: 100, valueGetter: (params: GridValueGetterParams) => {
        return formatter.format(params.value);
      },
    },
    { field: 'description', headerName: 'Description', width: 150 },
    { field: 'hubSpotDealID', headerName: 'HubSpot Deal ID', width: 150 },
    {
      field: 'fulfillment', headerName: 'Download', width: 80, renderCell: (params: GridRenderCellParams) => {
        if (params.value.downloadURL == "na") {
          return <div></div>
        } else if (params.value.downloadURL != "") {
          return <Button href={`${params.value.downloadURL}`} download={"TSG Order"} size="small" >
            <DownloadIcon color="primary" />
          </Button>
        } else {
          return <div>Pending...</div>
        }
      },
    },
  ]


  const { orders, loading, ordersError } = useMyOrders(customerID, balanceRefreshKey);
  const { storefronts } = useStorefronts(1);

  const customerIDChanged = (event: React.SyntheticEvent<Element, Event>, value: AutocompleteUser | null) => {
    if (value == null) {
      setCustomerID("")
    } else {
      setCustomerID(value.id)

      for (const user of users) {
        if (user.id == value.id) {
          setSelectedUser(user)
          setUserID(user.id)
          setUserFirstName(user.firstName)
          setUserLastName(user.lastName)
          setUserEmail(user.email)
          setUserPhone(user.phone)
          setUserSF(user.storefrontName)
          setUserMinOrder(user.settings.minOrderAmount.toString())
          setID('Customer ID:')
          setUserCreatedDate(user.createdAt)
          setUserHubspotID(user.hubspotCustomerID)
          setIgnoreSuppressions(user.settings.ignoreSuppressions)
          setOutputFields(user.settings.outputFieldSettings)
          setStripeID(user.stripeCustomerID)
          setSkipMarketingEmails(user.skipMarketingEmails)
          setIsInactive(user.isInactive)

          if (user.features != null) {
            setUserFeatures(user.features)
          } else {
            setUserFeatures([]);
          }
        }
      }
    }
  }

  function getShortDate(dateString: string | undefined) {
    if (dateString != undefined) {
      const dt = parse(dateString, 'YYYY-MM-DDTHH:mm:ss');
      return format(dt, "MM/DD/YY")
    }
  }

  const getWalletBalance = (wb: WalletBalance | undefined) => {
    if (wb != undefined && wb.balance != undefined) {
      return wb.balance.toLocaleString() + " leads"
    }

    return "0 leads"
  }


  useEffect(() => {
    const _hsq = (window._hsq = window._hsq || []);
    _hsq.push(["setPath", "/Customers"]);
    _hsq.push(["trackPageView"]);
  }, []);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  const orderDetailsStyle = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: props.storefront.activeColors.addProductForm.formBackground,
    border: '1px solid #5c5c5e',
    boxShadow: 24,
    p: 1,
  };

  const handleOrderDetailsClose = () => setOpenOrderDetails(false);

  const storefrontNameChanged = (event: SelectChangeEvent) => {
    setUserSF(event.target.value as string);
  }

  const featureFlagsChanged = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event;
    setUserFeatures(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const saveChanges = () => {
    const newuser = selectedUser;
    newuser.firstName = userFirstName
    newuser.lastName = userLastName
    newuser.phone = userPhone
    newuser.email = userEmail
    newuser.storefrontName = userSF
    newuser.hubspotCustomerID = userHubspotID
    newuser.stripeCustomerID = stripeID
    newuser.settings.minOrderAmount = parseFloat(userMinOrder)
    newuser.settings.ignoreSuppressions = ignoreSuppressions
    newuser.skipMarketingEmails = skipMarketingEmails
    newuser.isInactive = isInactive
    newuser.features = getFeatureFlags(userFeatures)

    setSaveError("")

    const apiURL = APIEndpoint(EndpointType.Users) + "/" + customerID;
    httpPut(apiURL, JSON.stringify(newuser))
      .then((data) => {
        const response = data as UsersResponse;

        if (response.status == 'error') {
          setSaveError("Error saving list: " + response.errorMessage)
        } else {
          
          setSnackbarMsg("Customer updated successfully")
          setOpenSnackbar(true)
        }
      })
      .catch((error) => {
        setSaveError(`List was not saved - error: ${error as string}`)
      });
  }

  function getFeatureFlags(features: string[]): FeatureFlag[] {
    const featureFlags: FeatureFlag[] = [];
    for (const feature of features) {
      if (Object.values(FeatureFlag).includes(feature as FeatureFlag)) {
        console.log("Feature flag: " + feature)
        const ff = feature as FeatureFlag;
        console.log("Feature flag: " + ff)
        featureFlags.push(ff);
      }
    }
    return featureFlags;
  }

      const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
          if (reason === 'clickaway') {
              return;
          }
  
          setOpenSnackbar(false);
      };

          const snackbarAction = (
              <React.Fragment>
                  <IconButton
                      size="small"
                      aria-label="close"
                      color="inherit"
                      onClick={handleSnackbarClose}
                  >
                      <CloseIcon fontSize="small" />
                  </IconButton>
              </React.Fragment>
          );
          
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
            <Title>Customers</Title>
            <Box sx={{ width: 600, marginTop: 2 }}>
              <Autocomplete
                disablePortal
                isOptionEqualToValue={(
                  option: AutocompleteUser,
                  value: AutocompleteUser
                ) => option.id === value.id}
                id="existingCustomer"
                onChange={customerIDChanged}
                options={autocompleteUsers}
                size="small"
                sx={{ width: 360 }}
                renderInput={(params) => (
                  <TextField {...params} label="Customer Name" />

                )}

              />

            </Box>

            {customerID != "" &&
              <Grid container spacing={3}>

                <Grid item xs={12}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography sx={{ width: 200, fontWeight: "bold" }}>{id}</Typography>
                    <Typography sx={{}}>{userID} <CopyToClipboard value={userID}></CopyToClipboard> </Typography>
                  </Stack>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography sx={{ width: 200, fontWeight: "bold" }}>Date Created:</Typography>
                    <Typography sx={{}}>{getShortDate(userCreatedDate)}</Typography>
                  </Stack>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Typography sx={{ width: 200, fontWeight: "bold" }}>Wallet Balance:</Typography>
                    <Typography>{getWalletBalance(walletBalance)}</Typography>
                  </Stack>

                </Grid>

                <Grid item xs={3}>
                  <TextField id="userFirstName" label="First Name" value={userFirstName} sx={{ width: 200 }} onChange={(e) => setUserFirstName(e.target.value) }></TextField>
                </Grid>

                <Grid item xs={3}>
                  <TextField id="userLastName" label="Last Name" value={userLastName} sx={{ width: 200 }} onChange={(e) => setUserLastName(e.target.value) }></TextField>
                </Grid>

                <Grid item xs={3}>
                  <TextField id="phone" label="Phone" value={userPhone} sx={{ width: 200 }} onChange={(e) => setUserPhone(e.target.value) }></TextField>
                </Grid>

                <Grid item xs={3}>
                  <TextField id="email" label="Email" value={userEmail} sx={{ width: 200 }} onChange={(e) => setUserEmail(e.target.value) }></TextField>
                </Grid>

                <Grid item xs={3}>
                  <FormControl sx={{ minWidth: 200 }}>
                    <InputLabel id="sfName">Storefront</InputLabel>
                    <Select
                      labelId="sfName"
                      id="sfName"
                      value={userSF}
                      label="Storefront"
                      onChange={storefrontNameChanged}
                      defaultValue={userSF}
                    >
                      {storefronts.map((sf) => {
                        return <MenuItem key={sf.storeName} value={sf.storeName}>{sf.storeName}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={3}>
                  <TextField id="minOrder" label="Minimum Order Amount" value={userMinOrder} sx={{ width: 200 }} onChange={(e) => setUserMinOrder(e.target.value) }></TextField>
                </Grid>

                <Grid item xs={3}>
                  <TextField id="hubspotID" label="Hubspot ID" value={userHubspotID} sx={{ width: 200 }} onChange={(e) => setUserHubspotID(e.target.value) }></TextField>
                </Grid>

                <Grid item xs={3}>
                  <TextField id="stripeID" label="Stripe ID" value={stripeID} sx={{ width: 200 }} onChange={(e) => setStripeID(e.target.value) }></TextField>
                </Grid>

                <Grid item xs={3}>
                  <FormControl sx={{ minWidth: 200 }}>
                    <InputLabel id="sfName">Beta Features</InputLabel>
                    <Select
                      labelId="featureFlags"
                      id="featureFlags"
                      multiple
                      value={userFeatures}
                      label="Beta Features"
                      onChange={featureFlagsChanged}
                    >
                      {Object.values(FeatureFlag).map((featureFlag) => (
                        <MenuItem key={featureFlag} value={featureFlag}>{featureFlag}</MenuItem>
                      ))}

                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={3}>
                  <Switch
                    checked={ignoreSuppressions}
                    onChange={(event) => {
                      setIgnoreSuppressions(event.target.checked);
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                  <FormHelperText>Skip Previous Order Suppression</FormHelperText>
                </Grid>

                <Grid item xs={3}>
                  <Switch
                    checked={skipMarketingEmails}
                    onChange={(event) => {
                      setSkipMarketingEmails(event.target.checked);
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                  <FormHelperText>Skip Marketing Email</FormHelperText>
                </Grid>

                <Grid item xs={3}>
                  <Switch
                    checked={isInactive}
                    onChange={(event) => {
                      setIsInactive(event.target.checked);
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                  <FormHelperText>Inactive User</FormHelperText>
                </Grid>

                <Grid item xs={12}>
                  {outputFields && outputFields.length > 0 &&
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Typography sx={{ width: 200, fontWeight: "bold" }}>Custom Output Fields</Typography>
                      <Stack direction="column" alignItems="center" spacing={2}>
                        <Stack direction="row" alignItems="center" spacing={2}>
                          {outputFields.map((field) => {
                            return <Stack direction="row" alignItems="center" spacing={1}>
                              <Typography sx={{}}>DataSource #{field.dataSourceID}:</Typography>
                              <Typography>{field.outputFields.join(",")}</Typography>
                            </Stack>
                          })}
                        </Stack>
                      </Stack>
                    </Stack>
                  }
                </Grid>

                <Grid item xs={3}>
                  <Button variant="contained" color="primary" sx={{ mt: 2, ml: 1 }} onClick={saveChanges}>
                    Save Changes
                  </Button>
                </Grid>

                <Grid item xs={9}>
                  {saveError != "" &&
                    <Alert severity="error" sx={{ mt: 3, ml: 1 }}>
                      {saveError}
                    </Alert>
                  }
                </Grid>


              </Grid>
            }

            <Grid marginTop={4} sx={{ height: "40vh"}}>
              <Typography sx={{ fontWeight: "bold" }}>Customer Orders:</Typography>
              {loading
                ? <LoadingSpinner title="Loading Orders..." textColor="#0352fc" />
                : ordersError
                  ? <ErrorFallBack message={ordersError} />
                  :
                  <DataGridPremium
                    rows={orders}
                    columns={columns}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                      },
                      sorting: {
                        sortModel: [{ field: 'id', sort: 'desc' }],
                      },
                    }}
                    pageSizeOptions={[5, 10, 25, 50]}

                  />
              }
            </Grid>

            <Box sx={{ marginTop: 4, minWidth: 460 }}>
              <Stack direction="column" spacing={0}>
                <Typography sx={{ fontWeight: "bold", mt: 2 }}>Wallet Transactions:</Typography>
                {walletTransactionsLoading
                  ? <LoadingSpinner title="Loading wallet..." textColor="#0352fc" />
                  : <WalletTransactionList transactions={walletTransactions} height="30vh"  />
                }
              </Stack>
            </Box>
          </Paper>
        </Grid>
      </Grid>
      <Modal
        open={openOrderDetails}
        onClose={handleOrderDetailsClose}
      >
        <Box sx={orderDetailsStyle}>
          <OrderDetails orderID={orderDetailsID} showFullDetails close={() => { setOpenOrderDetails(false) }} />
        </Box>
      </Modal>
                  <Snackbar
                      open={openSnackbar}
                      autoHideDuration={6000}
                      onClose={handleSnackbarClose}
                      message={snackbarMsg}
                      action={snackbarAction}
                  />
    </Container>
  );
};

export default Customers;
